import { memo } from 'react';
import CompetitorColumns from '@constants/competitors';
import classNames from 'classnames';
import styles from './styles.module.scss';

const Competitors = memo(() => (
  <div className={styles.container}>
    <div>
      <h1 className={styles.title}>Competitors</h1>
      <p className={styles.subtitle}>Competitor analysis of existing competitors.</p>
    </div>

    <div className={styles.columnContainer}>
      {CompetitorColumns.map(({ cells, isSelected }, colIndex) => (
        <div
          className={classNames(styles.column, {
            [styles.modColumnSelected]: isSelected,
          })}
          key={`column-${colIndex + 1}`}
        >
          {cells.map((cell, cellIndex) => (
            <div className={styles.cell} key={`cell-${cellIndex + 1}`}>
              {cell}
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
));

Competitors.displayName = 'Competitors';

export default Competitors;
